import React from "react";
import { Box, Typography, Divider } from "@mui/material";

/**
 * SectionSubheading - A reusable component for section headings with divider line
 *
 * @param {Object} props
 * @param {string} props.title - The heading text
 * @param {string} props.color - The color of the heading (default: "#881c29")
 * @param {Object} props.sx - Additional style properties for the container
 * @param {Object} props.titleSx - Additional style properties for the title
 * @param {Object} props.dividerSx - Additional style properties for the divider
 * @param {boolean} props.showDivider - Whether to show the divider (default: true)
 */
const SectionSubheading = ({
  title,
  color = "#881c29",
  sx = {},
  titleSx = {},
  dividerSx = {},
  showDivider = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 1,
        width: "100%",
        ...sx,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          color: color,
          fontSize: 18,
          letterSpacing: 0.1,
          textAlign: "left",
          mr: 2,
          ...titleSx,
        }}
      >
        {title}
      </Typography>
      {showDivider && (
        <Box sx={{ flex: 1, ml: 1, alignSelf: "center" }}>
          <Divider
            sx={{
              borderColor: "#e0e0e0",
              opacity: 1,
              ...dividerSx,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SectionSubheading;
